
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'icon-favorite',
    styleUrls: ['./icon-favorite.component.scss'],
    imports: [],
    template: `
        @if (isFavorite === true) {
          <div class="favorite">
            <i class="fa-solid fa-heart fa-lg"></i>
          </div>
        }
        
        @if (isFavorite === false) {
          <div class="not-favorite">
            <i class="fa-light fa-heart fa-lg"></i>
          </div>
        }
        `,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: true
})
export class IconFavoritComponent {

	@Input() isFavorite: boolean;

}
